<div class="row" *ngIf="label">
   <!-- <span role="text">{{ label }}</span> -->
   <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
      <h5>{{ label }}</h5>
   </div>

   <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 buttons">
      <button
         type="button"
         class="br-button secondary dark-mode mr-3"
         [ngClass]="{
            'secondary dark-mode': display,
            primary: !display
         }"
         (click)="addField()"
      >
         Adicionar
      </button>
      <button
         type="button"
         class="br-button secondary dark-mode mr-3"
         [ngClass]="{
            'secondary dark-mode': !display,
            primary: display
         }"
         (click)="removeField()"
      >
         Remover
      </button>
   </div>
</div>

<form action="submit" [formGroup]="formulario" *ngIf="display">
   <div class="row">
      <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
         <div class="br-textarea">
            <label for="slcJustivicativa"
               >Proposta
               <span class="required">*</span>
            </label>

            <textarea
               title="Proposta"
               class="form-control"
               formControlName="proposta"
               (input)="propostaValueChange($event.target.value)"
               [ngClass]="{
                  error:
                     formulario.get('proposta').invalid &&
                     formulario.get('proposta').touched,
                  success:
                     formulario.get('proposta').valid &&
                     formulario.get('proposta').touched
               }"
               [attr.rows]="3"
            ></textarea>

            <p
               [ngClass]="{
                  danger:
                     formulario.get('proposta').value &&
                     formulario.get('proposta').value.length > 5000
               }"
            >
               {{ formulario.get('proposta').value.length }} / 5000
            </p>

            <ng-container
               *ngIf="
                  formulario.get('proposta').invalid &&
                  formulario.get('proposta').touched
               "
            >
               <span class="feedback danger" role="alert">
                  <i class="fas fa-times-circle" aria-hidden="true"></i>
                  {{
                     formulario.get('proposta').errors &&
                     !formulario.get('proposta').errors.maxlength
                        ? 'O preenchimento desse campo é obrigatório'
                        : 'A quantidade de caracteres que você inseriu é maior que a permitida.'
                  }}</span
               >
               <br />
               <br />
            </ng-container>
         </div>
      </div>

      <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
         <div class="br-textarea">
            <label for="slcJustivicativa"
               >Justifique a necessidade da alteração
               <span class="required">*</span>
            </label>

            <textarea
               title="Justificativa"
               class="form-control"
               formControlName="justificativa"
               (input)="justificativaValueChange($event.target.value)"
               [ngClass]="{
                  error:
                     formulario.get('justificativa').invalid &&
                     formulario.get('justificativa').touched,
                  success:
                     formulario.get('justificativa').valid &&
                     formulario.get('justificativa').touched
               }"
               [attr.rows]="3"
            ></textarea>

            <p
               [ngClass]="{
                  danger:
                     formulario.get('justificativa').value &&
                     formulario.get('justificativa').value.length > 5000
               }"
            >
               {{ formulario.get('justificativa').value.length }} / 5000
            </p>

            <ng-container
               *ngIf="
                  formulario.get('justificativa').invalid &&
                  formulario.get('justificativa').touched
               "
            >
               <span class="feedback danger" role="alert">
                  <i class="fas fa-times-circle" aria-hidden="true"></i>
                  {{
                     formulario.get('justificativa').errors &&
                     !formulario.get('justificativa').errors.maxlength
                        ? 'O preenchimento desse campo é obrigatório'
                        : 'A quantidade de caracteres que você inseriu é maior que a permitida.'
                  }}</span
               >
               <br />
               <br />
            </ng-container>
         </div>
      </div>
   </div>
</form>
